import React from 'react';
import { ArrowBackIcon } from '@avila-tek/ui/src';

interface KpiItemProps {
  idx: number;
  title: string;
  total: number;
  difference?: number;
  differenceTitle: string;
}

function KpiItem({
  idx,
  title,
  total,
  difference,
  differenceTitle,
}: KpiItemProps) {
  return (
    <div
      className={`w-full md:w-1/4 flex flex-col justify-center gap-2 px-5  ${
        idx !== 3
          ? 'border-b border-r-0 py-3 md:py-0 md:border-r md:border-b-0 border-neutral-200'
          : 'border-none'
      }`}
    >
      <span className="text-purple-300 font-semibold ">{title}</span>
      <h4 className="text-2xl font-semibold text-text-gray">
        {Math.round(total)}
      </h4>
      <span className="text-text-black flex">
        <span
          className={`flex items-center ${
            (difference ?? 0) > 0 ? 'text-green-500' : 'text-red-500'
          }`}
        >
          {difference ? (
            <ArrowBackIcon
              className={`w-5 h-5 ${
                (difference ?? 0) > 0 ? 'rotate-90' : '-rotate-90'
              } `}
            />
          ) : null}
          {difference ? `${Math.round(difference)}%  ` : ''}
        </span>
        {difference ? differenceTitle : ''}
      </span>
    </div>
  );
}

export default KpiItem;
